import { TransportationModuleState } from "../store/TransportationModuleState";
import * as actions from "./actions";

/**
 * The Transportation Module Redux Reducer
 * @param state The IApplicationState for this reducer
 * @param action Standard Redux action payload of a type and payload 
 */
export function transportationReducer(state = new TransportationModuleState(), action: IReduxAction) {
    switch (action.type) {
        /**
         * Shipments
         */
        case actions.TRANSPORTATION_SHIPMENTS_CURRENT_TAB:
            return Object.assign({}, state, {
                selectedShipmentTab: action.payload
            }); 
        /**
         * Trucks
         */
        case actions.TRANSPORTATION_TRUCKS_SEARCH_UPDATE_FILTERS:
            return Object.assign({}, state, {
                truckSearchFilters: action.payload
            });
        case actions.TRANSPORTATION_TRUCKS_SEARCH_CLEAR_FILTERS:
            return Object.assign({}, state, {
                truckSearchFilters: {}
            });
        /**
         * Pickups
         */
        case actions.TRANSPORTATION_PICKUPS_SEARCH_UPDATE_FILTERS:
            return Object.assign({}, state, {
                pickupsSearchFilters: action.payload
            });        
        case actions.TRANSPORTATION_PICKUPS_SEARCH_CLEAR_PARAMS:
            return Object.assign({}, state, {
                pickupsSearchFilters: {}
            });
        /**
         * Containers
         */
        case actions.TRANSPORTATION_CONTAINERS_SEARCH_UPDATE_FILTERS:
            return Object.assign({}, state, {
                containerSearchFilters: action.payload
            });        
        case actions.TRANSPORTATION_CONTAINERS_SEARCH_CLEAR_FILTERS:
            return Object.assign({}, state, {
                containerSearchFilters: {}
            });
        /**
         * Fleet
         */
        case actions.TRANSPORTATION_FLEET_CURRENT_TAB:
            return Object.assign({}, state, {
                selectedFleetTab: action.payload
            }); 
        /**
         * Assets
         */
        case actions.TRANSPORTATION_FLEET_ASSETS_SEARCH_UPDATE_FILTERS:
            return Object.assign({}, state, {
                assetSearchFilters: action.payload
            });        
        case actions.TRANSPORTATION_FLEET_ASSETS_SEARCH_CLEAR_FILTERS:
            return Object.assign({}, state, {
                assetSearchFilters: {}
            });
        /**
         * Drivers
         */
        case actions.TRANSPORTATION_FLEET_DRIVERS_SEARCH_UPDATE_FILTERS:
            return Object.assign({}, state, {
                driversSearchFilters: action.payload
            });        
        case actions.TRANSPORTATION_FLEET_DRIVERS_SEARCH_CLEAR_FILTERS:
            return Object.assign({}, state, {
                driversSearchFilters: {}
            });            
        /**
         * Planning
         */
        case actions.TRANSPORTATION_PLANNING_DELIVERY_UPDATE_FILTERS:
            return Object.assign({}, state, {
                deliveryPlanningFilters: action.payload
            });
        case actions.TRANSPORTATION_PLANNING_DELIVERY_CLEAR_FILTERS:
            return Object.assign({}, state, {
                deliveryPlanningFilters: {}
            });
        case actions.TRANSPORTATION_PLANNING_CURRENT_TAB:
            return Object.assign({}, state, {
                selectedPlanningTab: action.payload
            });   
        default:
            return state;
    }
}
